module.exports = __webpack_public_path__ + "img/mail_gray.6b4503cb.svg";